export default "__VITE_ASSET__BY4_Sh73__"